import { FC } from 'react';
import { FooterContainer } from '../modules/footer/footer.container';
import { PrivacyPoliciesContainer } from '../modules/privacy-policies/PrivacyPolicies.container';

export const PrivacyAndPolicies: FC = () => {
  return (
    <>
      <PrivacyPoliciesContainer />
      <FooterContainer />
    </>
  );
};
